import { Alert, Button, Empty, Radio, Tooltip } from "antd";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import CustomIcon from "../../components/CustomIcon/CustomIcon";
import { DIMENSION_UNIT_SYSTEM } from "./dimensions.util";
import "./DimensionUnitSelector.scss";

const DimensionUnitSelector = ({ selectedUnitSystem, onUnitSystemChange, error, isEmpty, onRetry }) => {
  const { t } = useTranslation();

  return (
    <section className="dimension-unit-selector" aria-label={t("Dimensions.SectionLabel")}>
      <div className="dimension-unit-selector__control">
        <span>{t("Dimensions.UnitSelectorLabel")}</span>
        <Radio.Group
          aria-label={t("Dimensions.UnitSelectorAriaLabel")}
          buttonStyle="solid"
          onChange={event => onUnitSystemChange(event.target.value)}
          value={selectedUnitSystem}
        >
          <Radio.Button value={DIMENSION_UNIT_SYSTEM.US}>{t("Dimensions.US")}</Radio.Button>
          <Radio.Button value={DIMENSION_UNIT_SYSTEM.METRIC}>{t("Dimensions.Metric")}</Radio.Button>
        </Radio.Group>
        <Tooltip title={t("Dimensions.RoundingAndSourceTooltip")}>
          <CustomIcon
            aria-label={t("Dimensions.RoundingAndSourceAriaLabel")}
            className="dimension-unit-selector__info"
            name="InfoCircleOutlined"
            tabIndex={0}
          />
        </Tooltip>
      </div>
      {error ? (
        <Alert
          action={
            <Button onClick={onRetry} size="small" type="primary">
              {t("Dimensions.Retry")}
            </Button>
          }
          banner
          message={t("Dimensions.ErrorMessage")}
          showIcon
          type="error"
        />
      ) : null}
      {!error && isEmpty ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("Dimensions.EmptyMessage")} />
      ) : null}
    </section>
  );
};

DimensionUnitSelector.propTypes = {
  selectedUnitSystem: PropTypes.oneOf(Object.values(DIMENSION_UNIT_SYSTEM)).isRequired,
  onUnitSystemChange: PropTypes.func.isRequired,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object]),
  isEmpty: PropTypes.bool,
  onRetry: PropTypes.func.isRequired,
};

export default DimensionUnitSelector;
